import type React from 'react'

interface EyeClosedIconProps {
  size?: number | string
  color?: string
  className?: string
}

const EyeClosedIcon: React.FC<EyeClosedIconProps> = ({ size = 22, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Eye Closed Icon'}
      role="img"
    >
      <path
        d="M11.0002 6.67012C12.198 6.67014 13.2765 7.15544 14.0607 7.93965C14.3535 8.23246 14.3533 8.70731 14.0607 9.0002L9.0002 14.0607C8.70731 14.3533 8.23246 14.3535 7.93965 14.0607C7.15544 13.2765 6.67014 12.198 6.67012 11.0002C6.67012 8.60598 8.60598 6.67012 11.0002 6.67012ZM8.17012 11.0002C8.17013 11.5102 8.30514 11.9853 8.54121 12.3977L12.3977 8.54121C11.9853 8.30514 11.5102 8.17013 11.0002 8.17012C9.43441 8.17012 8.17012 9.43441 8.17012 11.0002Z"
        fill={color}
      />
      <path
        d="M11.0003 1.98012C13.2498 1.98016 15.4056 2.76393 17.2718 4.17153C17.6022 4.42087 17.6682 4.89069 17.4192 5.22133C17.1698 5.55202 16.6991 5.61823 16.3684 5.36879C14.7347 4.13649 12.8906 3.48016 11.0003 3.48012C7.78842 3.48012 4.71181 5.37178 2.52274 8.81313C2.1682 9.36864 1.96512 10.1648 1.96512 11.0055C1.96517 11.741 2.12052 12.4414 2.39676 12.9772L2.52274 13.1969L2.81082 13.6325C3.49573 14.6301 4.26666 15.4945 5.08914 16.2018C5.40303 16.4719 5.43919 16.9454 5.16922 17.2594C4.89914 17.5735 4.42468 17.6086 4.11063 17.3385C3.05073 16.4269 2.08323 15.3002 1.25711 14.0036C0.712266 13.1493 0.465181 12.0542 0.465119 11.0055C0.465119 9.95626 0.712673 8.86097 1.25809 8.00649C3.649 4.24851 7.15252 1.98012 11.0003 1.98012Z"
        fill={color}
      />
      <path
        d="M18.5803 6.34613C18.903 6.08652 19.3754 6.13763 19.635 6.46039C20.0183 6.93706 20.395 7.44924 20.7424 7.99653L20.841 8.15961C21.3176 8.9878 21.5354 10.0119 21.5354 10.9955C21.5353 12.0441 21.2871 13.1375 20.7424 13.9916L20.7434 13.9926C18.3525 17.7513 14.8483 20.0199 11.0002 20.02C9.66366 20.02 8.35497 19.7373 7.1291 19.2211C6.74739 19.0604 6.56798 18.6204 6.72871 18.2387C6.88954 17.8571 7.32946 17.6786 7.71113 17.8393C8.76523 18.2831 9.87678 18.52 11.0002 18.52C14.212 18.5199 17.2887 16.6292 19.4777 13.1879C19.8323 12.6325 20.0353 11.8361 20.0354 10.9955C20.0354 10.1548 19.8323 9.35868 19.4777 8.80317L19.4768 8.80219C19.1646 8.31027 18.8221 7.84258 18.466 7.39985C18.2065 7.07711 18.2576 6.60574 18.5803 6.34613Z"
        fill={color}
      />
      <path
        d="M13.7722 11.5644C13.8473 11.157 14.2388 10.8877 14.6462 10.9628C15.0534 11.038 15.3227 11.4286 15.2477 11.8359C14.9313 13.5517 13.5417 14.9413 11.8259 15.2577C11.4186 15.3327 11.028 15.0634 10.9528 14.6562C10.8777 14.2488 11.147 13.8573 11.5544 13.7822C12.6583 13.5784 13.5684 12.6683 13.7722 11.5644Z"
        fill={color}
      />
      <path
        d="M7.93957 12.9998C8.23242 12.707 8.70722 12.7071 9.00012 12.9998C9.29301 13.2927 9.29309 13.7679 9.0002 14.0607L1.53039 21.5301C1.2375 21.823 0.762739 21.823 0.469846 21.5301C0.177089 21.2372 0.176998 20.7624 0.469846 20.4696L7.93957 12.9998Z"
        fill={color}
      />
      <path
        d="M20.4696 0.469846C20.7624 0.176998 21.2372 0.177089 21.5301 0.469846C21.823 0.762739 21.823 1.2375 21.5301 1.53039L14.0607 9.0002C13.7679 9.29309 13.2927 9.29301 12.9998 9.00012C12.7071 8.70722 12.707 8.23242 12.9998 7.93957L20.4696 0.469846Z"
        fill={color}
      />
    </svg>
  )
}

export default EyeClosedIcon
